import React, { useEffect, useState, useRef, useContext } from 'react';
import classnames from 'classnames'
import { Container} from 'react-bootstrap';
import {  Program, ProgramDetail } from 'components';
import { useProgram } from 'hooks/useProgram';
import Loader from 'react-loader-spinner';
import theme from '../../themes/default';
import { FaChevronLeft } from 'react-icons/fa';
import {
  ShowMore,
  CloseButton,
  PageButton,
  ModalContainer,
  Header,
  Body,
  Spinner,
  DetailContainer,
  ProgramsContainer,
  ModalFooter,
} from './style'
import { I18nContext } from 'i18n'

const ProgramsModal = ({ organizationId, show, onHide, statusId }) => {
  const { dataPrograms, loadingPrograms, setOrgId } = useProgram({
    statusId: [statusId],
  })
  const [scholarships, setScholarships] = useState();
  const [rendering, setRendering] = useState(true);
  const [page, setPage] = useState(1);
  const [currentScroll, setCurrentScroll] = useState();
  const pageSize = 10;
  const theContent = useRef(null);
  const [showProgram, setShowProgram] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState();
  const [pastScroll, setPastScroll] = useState(0);
  const { translate } = useContext(I18nContext);

  const handleOnShow = () => {
    setOrgId(organizationId);
    setRendering(true);
  };

  const handleClick = (program) => {
    setSelectedProgram({...program, programOrganization: { organizationName: program?.programOrganizationName}});
    setPastScroll(theContent.current.scrollTop);
    setCurrentScroll(-1);
  };

  useEffect(() => {
    setShowProgram(!!selectedProgram);
  }, [selectedProgram]);

  useEffect(() => {
    if (dataPrograms) {
      const { programs } = dataPrograms;
      setScholarships(programs.slice(page - 1, pageSize));
      setRendering(false);
    }
  }, [dataPrograms]);

  useEffect(() => {
    if (page > 1) {
      const { programs } = dataPrograms;
      setCurrentScroll(theContent.current.scrollTop);
      setScholarships([
        ...scholarships,
        ...programs.slice((page - 1) * pageSize, pageSize * page),
      ]);
    }
  }, [page]);

  useEffect(() => {
    if (currentScroll && scholarships) {
      theContent.current.scrollTop = currentScroll;
    }
  }, [currentScroll, scholarships]);

  const handleGoBack = () => {
    setSelectedProgram(null);
    setTimeout(() => {
      setCurrentScroll(pastScroll);
    });
  };

  const renderShowMore = () => (
    <ShowMore>
      <CloseButton variant="link" onClick={() => setPage(page + 1)}>
        Show More
      </CloseButton>
    </ShowMore>
  );

  const renderReturn = () => (
    <PageButton variant="link" onClick={handleGoBack}>
      BACK TO LIST
    </PageButton>
  );

  return (
    <ModalContainer
      show={show}
      onHide={onHide}
      backdrop="static"
      onShow={() => handleOnShow()}
    >
      <Header closeButton>{showProgram && renderReturn()}</Header>
      <Body>
        <Container ref={theContent}>
          {loadingPrograms && (
            <Spinner>
              <Loader
                type="Oval"
                height={30}
                color={theme.palette.primary[0]}
                timeout={10000}
              />
            </Spinner>
          )}
          <DetailContainer open={showProgram}>
            {showProgram && selectedProgram && (
              <>
                <ProgramDetail program={selectedProgram} isMember={selectedProgram.isNspaMember} />
                {renderReturn()}
              </>
            )}
          </DetailContainer>
          <ProgramsContainer
            open={!showProgram}
            className={classnames({ programsContainer__empty: scholarships?.length === 0 })}
          >
            {
              scholarships?.length === 0 && (
                <h2 className="text-muted font-weight-light my-auto p-5">
                  {translate('not_programs_found')}
                </h2>
              )
            }
            {scholarships &&
              !rendering &&
              scholarships.map((program, index) => (
                <Program
                  key={index}
                  program={program}
                  onClick={() => handleClick(program)}
                />
              ))}
            {dataPrograms &&
              !rendering &&
              dataPrograms.programs?.length > page * pageSize &&
              renderShowMore()}
          </ProgramsContainer>
        </Container>
      </Body>
      <ModalFooter>
        <CloseButton variant="link" onClick={onHide}>
          Close
        </CloseButton>
      </ModalFooter>
    </ModalContainer>
  );
};

export default ProgramsModal;
